import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AlertController, LoadingController, NavController, Platform } from "@ionic/angular";
import { StatusBar } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import $ from "jquery";
import { Storage } from "@ionic/storage-angular";
import { register } from "swiper/element/bundle";
import { TranslateService } from "@ngx-translate/core";

register();

//export const serverRoute = "http://192.168.1.154:3095";
//export const serverRoute = "http://localhost:3000";
//export const serverRoute = "http://192.168.0.9:3095";
// export const serverRoute = "http://192.168.1.5:3095";

export const serverRoute = "https://desarrollo.i4life.es/silver-digi/prod";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent {
  routesWithoutMenu: string[] = ["/login", "/signup"];
  loggedIn = false;
  dark = false;

  idCouncil: string = "";
  serverroute: string = serverRoute;
  language: string = "es";
  protected hideAnnouncements: boolean = false;
  //Bragança no tiene sensores Dusun pero sí robot
  protected isBraganca: boolean = false;

  constructor(
    private platform: Platform,
    private router: Router,
    private navCtrl: NavController,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private storage: Storage,
    private translateService: TranslateService,
  ) {
    this.constructorCall();
  }

  async constructorCall() {
    await this.storage.create();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.storage.get("i4life-silver-digi-token").then((token: string) => {
          if (token === null || token === undefined || token.trim() === "") {
            this.navCtrl.navigateRoot("login");
            this.storage.remove("i4life-silver-digi-employeeName");
            this.storage.remove("i4life-silver-digi-employeeID");
          }
        });

        this.storage.get("i4life-silver-digi-idCouncil").then((id) => {
          if (id === "6915a6b6130bf81ba25c252e" || id === "69cadd07c28d98622945ac12") this.hideAnnouncements = true;
          else this.hideAnnouncements = false;
          this.isBraganca = id === "69cadd07c28d98622945ac12";
        });

        this.storage.get("i4life-silver-digi-rol").then((rol) => {
          if (rol == "admin") {
            $("#gestionBt").removeClass("noVisible");
          } else if (!$("#gestionBt").hasClass("noVisible")) {
            $("#gestionBt").addClass("noVisible");
          }
        });
      }
    });

    this.initializeApp();
    this.setLanguage();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is("hybrid")) {
        StatusBar.hide();
        SplashScreen.hide();
      }
    });

    this.storage.get("i4life-silver-digi-idCouncil").then((councilId) => {
      this.idCouncil = councilId;
    });
  }

  async logout() {
    const loading = await this.loadingController.create({
      message: "Por favor, espera ...",
    });
    // sessionStorage.clear();
    this.storage.remove("i4life-silver-digi-token");
    this.storage.remove("i4life-silver-digi-employeeName");
    this.storage.remove("i4life-silver-digi-employeeID");
    return this.navCtrl.navigateRoot("");
  }

  navigateToRoot(route: string) {
    this.navCtrl.pop();
    this.navCtrl.navigateRoot(route, {
      animated: true,
      animationDirection: "forward",
    });
  }

  openTutorial() {
    this.alertCtrl
      .create({
        header: this.translateService.instant("alerts.warning"),
        message: this.translateService.instant("alerts.only_phone"),
        buttons: [this.translateService.instant("buttons.ok")],
      })
      .then((res) => {
        res.present();
      });
  }

  toggle() {
    if (this.dark) {
      this.dark = false;
    } else {
      this.dark = true;
    }
  }

  async setLanguage() {
    const langs = ["es", "pt"];
    this.translateService.addLangs(langs);
    this.translateService.setDefaultLang("es");
    let lang = await this.storage.get("silver-digi-lang");
    if (lang && langs.includes(lang)) {
      this.language = lang;
      this.translateService.use(lang);
    } else {
      const browserLang = this.translateService.getBrowserLang();
      this.language = browserLang && langs.includes(browserLang) ? browserLang : "es";
      this.translateService.use(this.language);
      this.storage.set("silver-digi-lang", this.language);
    }
  }

  changeLanguage() {
    this.translateService.use(this.language);
    this.storage.set("silver-digi-lang", this.language);
  }
}
